export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/gig_page_perseus/paper-plane.5907351.svg";